export const CLEAR_REGISTRATION = 'REGISTRATION-CLEAR_REGISTRATION'
export const clearRegistration = () => ({
  type: CLEAR_REGISTRATION,
})

export const SET_ATTRIBUTE = 'REGISTRATION-SET_ATTRIBUTE'
export const setAttribute = (attribute, value) => ({
  attribute,
  value,
  type: SET_ATTRIBUTE,
})



// WEBPACK FOOTER //
// ./src/actions/registration.js